import React from 'react';
import { Edit } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';

const StateRateSettingEdit = () => (
  <Edit mutationMode="pessimistic" transform={getTransform(['state_id'], 'settings')}>
    <RateSettingsForm settingsField="settings" />
  </Edit>
);

export default StateRateSettingEdit;
